import routes from 'routes';
import { UserPermissions } from 'api/users/types';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import CodeIcon from '@mui/icons-material/Code';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SwitchLeftOutlinedIcon from '@mui/icons-material/SwitchLeftOutlined';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import LocalCafeRoundedIcon from '@mui/icons-material/LocalCafeRounded';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import ManageAccounts from '@mui/icons-material/Build';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';

type PermissionKey = keyof UserPermissions;

export type SidebarMenuItem = {
  title: string;
  icon: any;
  route: string;
  subMenus: null;
  permission?: PermissionKey;
};

const mainMenu: SidebarMenuItem[] = [
  // {
  //   title: 'Data Migration',
  //   icon: MoveUpIcon,
  //   route: routes.migration.list,
  //   subMenus: null,
  // },
  {
    title: 'Part Types',
    icon: MenuBookIcon,
    route: routes.partTypes.list,
    subMenus: null,
    permission: 'part-types',
  },
  {
    title: 'Part Type Studio',
    icon: AccountTreeOutlinedIcon,
    route: routes.partTypeStudio.root,
    subMenus: null,
    permission: 'part-type-studio',
  },
  {
    title: 'Vehicle Data',
    icon: DirectionsCarFilledIcon,
    route: routes.vehicleData.list,
    subMenus: null,
    permission: 'vehicle-data',
  },
  {
    title: 'Category Management',
    icon: CategoryOutlinedIcon,
    route: routes.categoryManagement.list,
    subMenus: null,
    permission: 'category_management',
  },
  {
    title: 'Parts Catalog',
    icon: MenuBookIcon,
    route: routes.partsCatalog.list,
    subMenus: null,
    permission: 'parts-catalog',
  },
  {
    title: 'Parts Decoder',
    icon: SwitchLeftOutlinedIcon,
    route: routes.partsDecoder.list,
    subMenus: null,
    permission: 'parts-decoder',
  },
  {
    title: 'Releases',
    icon: TipsAndUpdatesOutlinedIcon,
    route: routes.releases.list,
    subMenus: null,
    permission: 'releases',
  },
  {
    title: 'Office Hours',
    icon: LocalCafeRoundedIcon,
    route: routes.officeHours.list,
    subMenus: null,
    permission: 'office-hours',
  },
  {
    title: 'System Notices',
    icon: CampaignOutlinedIcon,
    route: routes.systemNotices.list,
    subMenus: null,
    permission: 'system-notices',
  },
  {
    title: 'HTMLs',
    icon: CodeIcon,
    route: routes.htmls.list,
    subMenus: null,
    permission: 'ebay-html',
  },
  {
    title: 'Labels',
    icon: LocalOfferOutlinedIcon,
    route: routes.labels.list,
    subMenus: null,
    permission: 'ebay-html',
  },
  {
    title: 'Learn Content',
    icon: SchoolOutlinedIcon,
    route: routes.learnContent.list,
    subMenus: null,
    permission: 'learn-content',
  },
  {
    title: 'Feedback Management',
    icon: FeedbackOutlinedIcon,
    route: routes.feedbackManagement.list,
    subMenus: null,
    permission: 'feedback-management',
  },
  {
    title: 'Saturn Migration',
    icon: MenuBookIcon,
    route: routes.saturnMigration.list,
    subMenus: null,
    permission: 'saturn-migration',
  },
  {
    title: 'DPC Management',
    icon: ManageAccounts,
    route: routes.DPCManagement.list,
    subMenus: null,
    permission: 'dpc-management',
  },
  {
    title: 'Stores',
    icon: StorefrontOutlinedIcon,
    route: routes.stores.list,
    subMenus: null,
    permission: 'stores',
  },
  {
    title: 'Users',
    icon: PeopleOutlineOutlinedIcon,
    route: routes.users.list,
    subMenus: null,
    permission: 'users',
  },
  {
    title: 'Record Diagnostics',
    icon: ManageSearchOutlinedIcon,
    route: routes.recordDiagnostics.list,
    subMenus: null,
    permission: 'record-diagnostics',
  },
  {
    title: 'Logout',
    icon: LogoutIcon,
    route: routes.login,
    subMenus: null,
  },
];

const hasMenuPermission = (permissionsSchema: Partial<UserPermissions> | null | undefined, permission?: PermissionKey) => {
  if (!permission) {
    return true;
  }

  if (!permissionsSchema) {
    return false;
  }

  return Boolean(permissionsSchema[permission]);
};

export const fetchMainMenu = (permissionsSchema?: Partial<UserPermissions> | null): SidebarMenuItem[] => {
  return mainMenu.filter((menuItem) => hasMenuPermission(permissionsSchema, menuItem.permission));
};
